const SIZE_LABELS = {
  2: 'Direktbyte',
  3: 'Trepartsbyte',
  4: 'Fyrpartsbyte'
}

export function swapSizeLabel (size) {
  return SIZE_LABELS[size] || size + '-parts'
}

// Derive the user's prior interest choice from the bucket the suggestion
// currently lives in. Returns 1 (interested), 0 (not interested), or null
// (undecided / other party's state).
export function bucketToInterest (bucket) {
  if (
    bucket === 'pending' ||
    bucket === 'ready' ||
    bucket === 'rejected_by_other' ||
    bucket === 'archived_matches'
  ) {
    return 1
  }
  if (bucket === 'rejected_by_me') {
    return 0
  }
  return null
}
